import React from 'react';
import styled, { css } from 'styled-components';
import mergeClassNames from '../../lib/style-helpers/merge-class-name';
import { FontType, FontSize } from '../../../../config/theme/types/themeTypes';
import { StyledWithChildrenProps } from '../../types/StyledWithChildrenProps';

function H3({
  className,
  children,
  ...props
}: StyledWithChildrenProps) {
  return (
    <Header
      className={mergeClassNames('H3', className)}
      {...props}
    >
      {children}
    </Header>
  );
}

const Header = styled.h2 < StyledWithChildrenProps > `
  ${({ theme }) => css`
    ${theme.font(FontType.Strong, FontSize.H3)}
    ${theme.media.tablet} {
      ${theme.font(FontType.Strong, FontSize.H4)}
    }
  `}
`;

export default H3;
